import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => {
  const stacked = `@media (max-width: ${theme.screens.small_desktop - 1}px)`;
  return {
    workspace: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(4),
      marginBottom: 200
    },
    breadcrumb: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(1.5),
      fontSize: 13,
      color: theme.colorPalette.beige_90,
      '& a': {
        color: 'inherit',
        textDecoration: 'underline',
        textUnderlineOffset: '3px'
      }
    },
    header: {
      display: 'grid',
      gridTemplateColumns: 'auto minmax(0, 1fr)',
      gap: theme.spacing(3.5, 4.5),
      alignItems: 'center'
    },
    initials: {
      width: 56,
      height: 56,
      borderRadius: theme.spacing(4),
      backgroundColor: theme.colorPalette.green_75,
      color: theme.colorPalette.white,
      display: 'grid',
      placeItems: 'center',
      fontSize: 20,
      fontWeight: 700
    },
    identity: {
      minWidth: 0
    },
    name: {
      margin: 0
    },
    meta: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: theme.spacing(1.5, 3.5),
      marginTop: theme.spacing(1.5),
      fontSize: 14,
      color: theme.colorPalette.beige_90
    },
    accountId: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      fontVariantNumeric: 'tabular-nums'
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(1.5),
      marginTop: theme.spacing(2.5)
    },
    chip: {
      backgroundColor: theme.colorPalette.white,
      border: `1px solid ${theme.colorPalette.beige_60}`
    },
    statusChip: {
      backgroundColor: theme.colorPalette.white,
      border: `1px solid ${theme.colorPalette.beige_60}`,
      gap: theme.spacing(1.5)
    },
    statusChipActive: {
      backgroundColor: theme.colorPalette.green_75_10,
      borderColor: 'transparent',
      color: theme.colorPalette.green_75,
      '&::before': {
        content: '""',
        width: 7,
        height: 7,
        borderRadius: '50%',
        backgroundColor: 'currentColor'
      }
    },
    affinityChip: {
      backgroundColor: 'transparent',
      border: `1px solid ${theme.colorPalette.beige_60}`,
      color: theme.colorPalette.beige_90,
      gap: theme.spacing(2)
    },
    tabs: {
      borderBottom: `1px solid ${theme.colorPalette.beige_60}`,
      minHeight: 0,
      '& [class*="MuiTabs-flexContainer"]': {
        justifyContent: 'flex-start',
        gap: theme.spacing(0.5)
      },
      '& [class*="MuiTabs-indicator"]': {
        height: 3
      }
    },
    tab: {
      minWidth: 0,
      minHeight: 44,
      fontSize: 15,
      fontWeight: 600,
      color: theme.colorPalette.beige_90,
      opacity: 1,
      '&.Mui-selected': {
        color: theme.colors.action_text
      },
      '& [class*="MuiTab-wrapper"]': {
        padding: theme.spacing(0, 3)
      }
    },
    panel: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(4),
      minWidth: 0
    },
    // Today's sidebar cards keep their design width on the right; the main column takes the rest.
    columns: {
      display: 'grid',
      gridTemplateColumns: `minmax(0, 1fr) ${theme.sizes.sideColumn}px`,
      gap: theme.spacing(8),
      alignItems: 'start',
      [stacked]: { gridTemplateColumns: 'minmax(0, 1fr)' }
    },
    mainColumn: {
      minWidth: 0
    },
    sideColumn: {
      minWidth: 0
    }
  };
};

export default makeStyles(styles);
